import React, { useState, useReducer } from "react";
import { Table, Row, Col, Form, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { FaSearch } from "react-icons/fa";
import { TENANT_BUCKET, HISTORY_TABLE_FIELD } from "../../../../common/constants";
import { useNavigate } from "react-router-dom";
import { useMiddletier } from "../../../../common/middletier";
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../../../common/storeContext';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Loading from '../../../../components/Loading';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const HISTORY_ACTION = {
  SET_TRANSACTION_TYPE: 'SET_TRANSACTION_TYPE',
  SET_SELECTED_TRANSACTION_TYPE: 'SET_SELECTED_TRANSACTION_TYPE',
  SET_SELECTED_START_DATE: 'SET_SELECTED_START_DATE',
  SET_SELECTED_END_DATE: 'SET_SELECTED_END_DATE',
  SET_SELECTED_MONTH: 'SET_SELECTED_MONTH',
  SET_SELECTED_YEAR: 'SET_SELECTED_YEAR',

  SET_HISTORY_TRANSACTION: 'SET_HISTORY_TRANSACTION',
}
//  [{ id: 'DEPOSIT_WITHDRAW', name: 'deposit_withdrawal' }, { id: 'TRANSFER', name: 'transfer' }, { id: 'BETTING_SUMMARY', name: 'betting_summary' }, { id: 'PROMOTION_APPLY', name: 'promotion_apply' }, { id: 'REBATE', name: 'rebate' }]

const initialHistoryData = {
  transactionType: [{ id: 'MONTHLY_WIN_LOSS', name: 'monthly_win_loss' }, { id: 'MONTHLY_COMMISSION', name: 'monthly_commission' }, { id: 'WITHDRAW', name: 'withdraw' }, { id: 'DEPOSIT', name: 'deposit' }, { id: 'TRANSFER', name: 'transfer' }, { id: 'MEMBER', name: 'member' }],
  selectedtransactionType: { id: 'MONTHLY_WIN_LOSS', name: 'monthly_win_loss' },
  selectedStartDate: null,
  selectedEndDate: null,
  selectedMonth: null,
  selectedYear: null,
  historyTransaction: []
}


const historyReducer = (state, action) => {
  switch (action.type) {

    case HISTORY_ACTION.SET_TRANSACTION_TYPE: {
      const transactionType = [...action.payload]
      return { ...state, transactionType, selectedtransactionType: transactionType.length > 0 ? transactionType[0] : '' };
    }

    case HISTORY_ACTION.SET_SELECTED_TRANSACTION_TYPE: {
      const selectedtransactionType = state.transactionType.find((transactionType) => transactionType.id === action.payload)
      return { ...state, selectedtransactionType };
    }

    case HISTORY_ACTION.SET_SELECTED_START_DATE: {
      return { ...state, selectedStartDate: action.payload };
    }

    case HISTORY_ACTION.SET_SELECTED_END_DATE: {
      return { ...state, selectedEndDate: action.payload };
    }

    case HISTORY_ACTION.SET_SELECTED_MONTH: {
      return { ...state, selectedMonth: action.payload };
    }

    case HISTORY_ACTION.SET_SELECTED_YEAR: {
      return { ...state, selectedYear: action.payload };
    }

    case HISTORY_ACTION.SET_HISTORY_TRANSACTION: {
      return { ...state, historyTransaction: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}


function History() {
  const appDispatch = useStoreDispatch()
  const { t } = useTranslation();
  const { query } = useMiddletier();
  const appState = useStoreState();
  const [historyState, historyDispatch] = useReducer(historyReducer, initialHistoryData)
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);
  const [currentDetails, setCurrentDetails] = useState(null);
  // const [selected, setSelected] = React.useState();
  const navigate = useNavigate();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  dayjs.extend(utc);
  dayjs.extend(timezone);

  // const _timezone = appState.timezone ?? 'Asia/Kuala_Lumpur';

  const itemsPerPage = 20;

  const maxPage = Math.ceil(historyState.historyTransaction?.length / itemsPerPage);

  const today = dayjs().tz(appState.timezone).format('YYYY-MM-DD');

  // const formatAmount = (amount, decimalPoint) => {
  //   const factor = Math.pow(10, decimalPoint);
  //   const truncatedAmount = Math.floor(amount * factor) / factor;
  //   const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
  //     minimumFractionDigits: decimalPoint,
  //     maximumFractionDigits: decimalPoint,
  //   });
  //   return formattedAmount;
  // }

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, decimalPoint);
    const truncatedAmount = Math.trunc(amount * factor) / factor;

    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: decimalPoint,
      maximumFractionDigits: decimalPoint,
    });

    return formattedAmount;
  }

  const onChangeTransactionType = (newValue) => {
    if (newValue === 'MONTHLY_COMMISSION') {
      setCurrentDetails([])
    } else {
      setCurrentDetails(null)
    }
    historyDispatch({ type: HISTORY_ACTION.SET_SELECTED_TRANSACTION_TYPE, payload: newValue })
    historyDispatch({ type: HISTORY_ACTION.SET_HISTORY_TRANSACTION, payload: [] })
    setCurrentPage(1)
  }

  const onChangeStartDate = (startDate, endDate) => {
    // console.log('startDate:',dayjs(startDate).isAfter(endDate))

    if (dayjs(startDate).isAfter(today)) {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: 'Start date cannot be after today.', typeAlert: 'error' }
      });
      return;
    }

    if (dayjs(startDate).isAfter(endDate)) {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: 'Start date cannot be after end date.', typeAlert: 'error' }
      });
      return;
    } else {
      historyDispatch({ type: HISTORY_ACTION.SET_SELECTED_START_DATE, payload: startDate })
    }

  }

  const onChangeEndDate = (startDate, endDate, today) => {

    if (dayjs(endDate).isAfter(today)) {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: 'End date cannot be after today.', typeAlert: 'error' }
      });
      return;
    }
    if (dayjs(endDate).isBefore(startDate)) {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: 'End date cannot be before start date.', typeAlert: 'error' }
      });
      return;
    }

    historyDispatch({ type: HISTORY_ACTION.SET_SELECTED_END_DATE, payload: endDate })
  }

  const onChangeMonth = (month) => {
    historyDispatch({ type: HISTORY_ACTION.SET_SELECTED_MONTH, payload: month })
  }

  const onChangeYear = (year) => {
    historyDispatch({ type: HISTORY_ACTION.SET_SELECTED_YEAR, payload: year })
  }


  const handleSubmit = () => {

    let method, params, attributes, getTransactionData, filterValue

    // GET FROM DATE AND END DATE
    const formDate = historyState.selectedStartDate ? (dayjs(historyState.selectedStartDate).tz(appState.timezone, true).startOf('day') === 'Invalid date' ? '' : dayjs(historyState.selectedStartDate).tz(appState.timezone, true).startOf('day')) : '';
    const endDate = historyState.selectedEndDate ? (dayjs(historyState.selectedEndDate).tz(appState.timezone, true).endOf('day') === 'Invalid date' ? '' : dayjs(historyState.selectedEndDate).tz(appState.timezone, true).endOf('day')) : dayjs().tz(appState.timezone, true).endOf('day');
    const month = historyState.selectedMonth ? `${historyState.selectedMonth?.getFullYear()}-${historyState.selectedMonth?.getMonth() + 1 < 10 ? '0' : ''}${historyState.selectedMonth?.getMonth() + 1}` : ''
    const year = historyState.selectedYear ? `${historyState.selectedYear?.getFullYear()}` : ''

    // console.log('formDate: ', formDate)
    // console.log('endDate: ', endDate)


    // CHECK TRANSACTION TYPE
    if (historyState.selectedtransactionType?.id === 'TRANSFER') {
      method = 'getAffiliateDepositTransactions'
      filterValue = {
        where: { affiliate: appState.user?.username, transaction_type: "TRANSFER", ...(formDate !== '' && endDate !== '' ? { transaction_at: { "$between": [formDate, endDate] } } : {}) },
        order: [['transaction_at', 'DESC']]
      };
      params = [
        { code: 'filter', graphqlType: 'JSON', required: true, value: filterValue },
      ]
      attributes = ['id', ['transaction_at', 'transaction_date'], 'amount', 'currency', ['transfer_target', 'type'], ['target_user', 'target_login']]
    }

    else if (historyState.selectedtransactionType?.id === 'DEPOSIT') {
      method = 'getAffiliateDepositTransactions'
      filterValue = {
        where: { affiliate: appState.user?.username, transaction_type: "DEPOSIT", ...(formDate !== '' && endDate !== '' ? { transaction_at: { "$between": [formDate, endDate] } } : {}) },
        order: [['transaction_at', 'DESC']]
      };
      params = [
        { code: 'filter', graphqlType: 'JSON', required: true, value: filterValue },
      ]
      attributes = ['id', ['transaction_at', 'transaction_date'], 'amount', 'currency', 'status']

    }

    else if (historyState.selectedtransactionType?.id === 'WITHDRAW') {
      method = 'getAffiliateWalletTransactions'
      filterValue = {
        where: { affiliate: appState.user?.username, transaction_type: "WITHDRAW", ...(formDate !== '' && endDate !== '' ? { transaction_at: { "$between": [formDate, endDate] } } : {}) },
        order: [['transaction_at', 'DESC']]
      };
      params = [
        { code: 'filter', graphqlType: 'JSON', required: true, value: filterValue },
      ]
      attributes = ['id', ['transaction_at', 'transaction_date'], 'amount', 'currency', 'status']

    }

    else if (historyState.selectedtransactionType?.id === 'MEMBER') {
      method = 'getAffiliateReportMember'

      if (formDate !== '' && endDate !== '') {
        params = [
          { code: 'affiliate', graphqlType: 'String', required: false, value: appState.user?.username },
          { code: 'fromDate', graphqlType: 'Date', required: true, value: historyState.selectedStartDate ? (dayjs(historyState.selectedStartDate).tz(appState.timezone).startOf('day').format('YYYY-MM-DD') === 'Invalid date' ? '' : dayjs(historyState.selectedStartDate).tz(appState.timezone).startOf('day').format('YYYY-MM-DD')) : '' },
          { code: 'toDate', graphqlType: 'Date', required: true, value: historyState.selectedEndDate ? (dayjs(historyState.selectedEndDate).tz(appState.timezone).endOf('day').format('YYYY-MM-DD') === 'Invalid date' ? '' : dayjs(historyState.selectedEndDate).tz(appState.timezone).endOf('day').format('YYYY-MM-DD')) : dayjs().tz(appState.timezone).endOf('day').format('YYYY-MM-DD') },
        ]
      } else {
        params = []
        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: 'Please Select Date', typeAlert: 'error' }
        });
      }

      // console.log('params', params)
      attributes = []

    }

    else if (historyState.selectedtransactionType?.id === 'MONTHLY_WIN_LOSS') {
      method = 'getAffiliateReportMonthlyWinLoss'

      if (month !== '') {
        params = [
          { code: 'affiliate', graphqlType: 'String', required: false, value: appState.user?.username },
          { code: 'searchMonth', graphqlType: 'String', required: true, value: month ?? '' },

        ]
      } else {
        params = []
        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: 'Please Select Month', typeAlert: 'error' }
        });
      }

      // console.log('params', params)
      attributes = []

    }
    else if (historyState.selectedtransactionType?.id === 'MONTHLY_COMMISSION') {
      method = 'getAffiliateReportMonthlyCommission'
      if (year !== '') {
        params = [
          { code: 'searchYear', graphqlType: 'String', required: false, value: year },
        ]
      } else {
        params = []
        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: 'Please Select Year', typeAlert: 'error' }
        });
      }
      attributes = []
    }

    else {
      historyDispatch({ type: HISTORY_ACTION.SET_HISTORY_TRANSACTION, payload: [] })
    }

    // console.log('fliter value: ', filterValue)

    if (method) {
      setLoading(true)
      query({
        method,
        params,
        attributes

      }).then(({ data }) => {

        setLoading(false)

        if (historyState.selectedtransactionType?.id === 'TRANSFER') {

          getTransactionData = data[method]?.map((item) => {
            // let transferFrom = (item.transaction_type === 'TRANSFER_IN' ? item.game_provider : 'Main Wallet')
            // let transferTo = (item.transaction_type === 'TRANSFER_IN' ? 'Main Wallet' : item.game_provider)

            return { transaction_date: dayjs(item.transaction_date).tz(appState?.timezone).format('YYYY-MM-DD  HH:mm:ss'), type: item.type, currency: item.currency, amount: formatAmount(item.amount ?? 0, appState.currencyFormat.decimal_point), target_login: item.target_login };
          })

        } else if (historyState.selectedtransactionType?.id === 'DEPOSIT') {

          getTransactionData = data[method]?.map((item) => {
            return { currency: item.currency, transaction_date: item.transaction_date ? dayjs(item.transaction_date).tz(appState?.timezone).format('YYYY-MM-DD  HH:mm:ss') : '-', amount: formatAmount(item.amount ?? 0, appState.currencyFormat.decimal_point), status: item.status };
          })

        }

        else if (historyState.selectedtransactionType?.id === 'WITHDRAW') {

          getTransactionData = data[method]?.map((item) => {
            return { currency: item.currency, transaction_date: item.transaction_date ? dayjs(item.transaction_date).tz(appState?.timezone).format('YYYY-MM-DD  HH:mm:ss') : '-', amount: formatAmount(item.amount ?? 0, appState.currencyFormat.decimal_point), status: item.status };
          })

        }

        else if (historyState.selectedtransactionType?.id === 'MEMBER') {

          getTransactionData = data[method]?.map((item) => {
            return { member: item.member, registered_date: item.registered_date ? dayjs(item.registered_date).tz(appState?.timezone).format('YYYY-MM-DD  HH:mm:ss') : '-', ftd_amount: item.ftd_amount > 0 ? formatAmount(item.ftd_amount ?? 0, appState.currencyFormat.decimal_point) : '-', currency: item.currency, ftd_date: item.ftd_date ? dayjs(item.ftd_date).tz(appState?.timezone).format('YYYY-MM-DD  HH:mm:ss') : '-' };
          })

        }
        else if (historyState.selectedtransactionType?.id === 'MONTHLY_WIN_LOSS') {

          getTransactionData = data[method]?.map((item) => {
            return { member: item.member, month: item.month, company_wl: formatAmount(item.company_win_loss ?? 0, appState.currencyFormat.decimal_point), turnover: formatAmount(item.turnover ?? 0, appState.currencyFormat.decimal_point), summary: item.summary };
          })

        }
        else if (historyState.selectedtransactionType?.id === 'MONTHLY_COMMISSION') {

          getTransactionData = data[method]?.map((item) => {
            return {
              id: item.id,
              currency: item.currency,
              active_member: item.active_member,
              commission_start_date: item.commission_start_date ? dayjs(item.commission_start_date).tz(appState?.timezone).format('YYYY-MM-DD') : '-',
              commission_end_date: item.commission_end_date ? dayjs(item.commission_end_date).tz(appState?.timezone).format('YYYY-MM-DD') : '-',
              win_loss: formatAmount(item.total_win_loss ?? 0, appState.currencyFormat.decimal_point),
              shared_cost: formatAmount(item.total_shared_cost ?? 0, appState.currencyFormat.decimal_point),
              commission_rate: formatAmount(item.commission_rate ?? 0, appState.currencyFormat.decimal_point),
              calculated_commission: formatAmount(item.final_calculated_commission ?? 0, appState.currencyFormat.decimal_point),
              last_month_carry_forward: formatAmount(item.last_carry_forward ?? 0, appState.currencyFormat.decimal_point),
              commission: formatAmount(item.total_entitled_commission ?? 0, appState.currencyFormat.decimal_point),
              carry_forward: formatAmount(item.carry_forward ?? 0, appState.currencyFormat.decimal_point),
              actual_release: formatAmount(item.total_release_commission ?? 0, appState.currencyFormat.decimal_point),
              status: item.status
            };
          })

        }
        // console.log('getTransactionData', getTransactionData)
        // historyDispatch({ type: HISTORY_ACTION.SET_HISTORY_TRANSACTION, payload: getTransactionData })

        historyDispatch({ type: HISTORY_ACTION.SET_HISTORY_TRANSACTION, payload: getTransactionData })


      }).catch((error) => {
        setLoading(false)
        console.error(error)
        if (error?.networkError?.statusCode === 401) {
          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
        } else {
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: error.message.toString(), typeAlert: 'error' }
          });
        }
      })

    }
  }


  const createPagination = () => {
    let pages = [];
    for (let i = 1; i <= maxPage; i++) {
      pages.push(<button onClick={() => setCurrentPage(i)} key={i} className={`paginationNumber ${currentPage === i && 'active color_active'} `}>{i}</button>);
    }
    return pages;
  }

  const nextPage = () => {
    setCurrentPage((oldPage) => Math.min(oldPage + 1, maxPage));
  };

  const previousPage = () => {
    setCurrentPage((oldPage) => Math.max(oldPage - 1, 1));
  };

  const onClickDetailsDialog = (item) => {

    if (historyState.selectedtransactionType?.id === 'MONTHLY_COMMISSION') {
      setLoading(true)
      query({
        method: 'getAffiliateReportMonthlyCommission',
        params: [
          { code: 'transactionId', graphqlType: 'Int', required: false, value: item },
        ],
        attributes: []

      }).then(({ data }) => {
        setLoading(false)
        let getTransactionData = data['getAffiliateReportMonthlyCommission']?.map((item) => {
          return {
            id: item.id,
            currency: item.currency,
            calculated_commission: formatAmount(item.calculatedCommission ?? 0, appState.currencyFormat.decimal_point),
            other_cost: formatAmount(item.totalSharedCost ?? 0, appState.currencyFormat.decimal_point),
            commission_rate: formatAmount(item.commissionRate ?? 0, appState.currencyFormat.decimal_point),
            active_member: item.active_member,
            final_calculated_commission: formatAmount(item.finalCalculatedCommssion ?? 0, appState.currencyFormat.decimal_point),
            final_other_cost: formatAmount((item.totalSharedCost * (item.commissionRate / 100)) ?? 0, appState.currencyFormat.decimal_point),
            transactions: item.transactions?.map((_item) => {
              return {
                currency: _item.currency,
                provider_details: _item._game_provider?.name,
                company_wl: formatAmount(_item.win_loss ?? 0, appState.currencyFormat.decimal_point),
                other_cost: '-',
                royalty_fee_rate: formatAmount(_item.royalty_fee_rate ?? 0, appState.currencyFormat.decimal_point),
                royalty_fee: formatAmount(_item.royalty_fee ?? 0, appState.currencyFormat.decimal_point),
                bonus: formatAmount(_item.bonus_amount ?? 0, appState.currencyFormat.decimal_point),
                actual_rebate: formatAmount(_item.rebate_amount ?? 0, appState.currencyFormat.decimal_point),
                commission_rate: formatAmount(_item.commission_rate ?? 0, appState.currencyFormat.decimal_point),
                calculated_commission: formatAmount(_item.calculated_commission ?? 0, appState.currencyFormat.decimal_point),

              };
            }),
            total_member_deposit: [{
              provider_details: t('total_member_deposit'),
              company_wl: '-',
              other_cost: formatAmount(item.totalDeposit ?? 0, appState.currencyFormat.decimal_point),
              royalty_fee_rate: formatAmount(item.depositFeeRate ?? 0, appState.currencyFormat.decimal_point),
              royalty_fee: formatAmount(item.depositSharedCost ?? 0, appState.currencyFormat.decimal_point),
              bonus: '-',
              actual_rebate: '-',
              commission_rate: formatAmount(item.commissionRate ?? 0, appState.currencyFormat.decimal_point),
              calculated_commission: formatAmount(item.finalDepositSharedCost ?? 0, appState.currencyFormat.decimal_point),

            }],
            total_member_withdraw: [{
              provider_details: t('total_member_withdraw'),
              company_wl: '-',
              other_cost: formatAmount(item.totalWithdrawal ?? 0, appState.currencyFormat.decimal_point),
              royalty_fee_rate: formatAmount(item.withdrawalFeeRate ?? 0, appState.currencyFormat.decimal_point),
              royalty_fee: formatAmount(item.withdrawalSharedCost ?? 0, appState.currencyFormat.decimal_point),
              bonus: '-',
              actual_rebate: '-',
              commission_rate: formatAmount(item.commissionRate ?? 0, appState.currencyFormat.decimal_point),
              calculated_commission: formatAmount(item.finalWithdrawalSharedCost ?? 0, appState.currencyFormat.decimal_point),

            }],
            totals: [{
              provider_details: t('total'),
              company_wl: formatAmount(item.totalCompanyWinLoss ?? 0, appState.currencyFormat.decimal_point),
              other_cost: formatAmount(item.totalSharedCost ?? 0, appState.currencyFormat.decimal_point),
              royalty_fee_rate: '-',
              royalty_fee: formatAmount(item.totalRoyaltyFee ?? 0, appState.currencyFormat.decimal_point),
              bonus: formatAmount(item.totalBonus ?? 0, appState.currencyFormat.decimal_point),
              actual_rebate: formatAmount(item.totalRebate ?? 0, appState.currencyFormat.decimal_point),
              commission_rate: formatAmount(item.commission_rate ?? 0, appState.currencyFormat.decimal_point),
              calculated_commission: formatAmount(item.finalCalculatedCommssion ?? 0, appState.currencyFormat.decimal_point),

            }]
          }
        })
        // setCurrentDetails(data['getAffiliateReportMonthlyCommission'])
        setCurrentDetails(getTransactionData)


      }).catch((error) => {
        setLoading(false)
        console.log('error: ', error)
        if (error?.networkError?.statusCode === 401) {
          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
        } else {
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: error.message.toString(), typeAlert: 'error' }
          });
        }
      })
    } else {
      setCurrentDetails(item)
    }

    setShowDetailsDialog(true)

  };


  return (
    <>
      <div className="history_body">
        {/* {isDesktopOrLaptop && <div className="font_h2 color_primary wallet_container_title">{t('history')}</div>} */}
        <div className="wallet_container_wrap">
          {/* {isDesktopOrLaptop ? */}
          <Form className="history_form">
            <Row>
              <Form.Group className="mb-3" >
                <Form.Label>{t('report_type')} :
                  <span className="form_required_input">* {t('required_select')}</span>
                </Form.Label>
                <div className="transactionTypeTab">
                  {historyState.transactionType.map(function (item, index) {
                    return (
                      <span key={item.id} className={`transactionType_selection ${historyState.selectedtransactionType?.id === item.id ? 'color_active active' : ''}`} onClick={() => onChangeTransactionType(item.id)}>
                        {(t(item.name))}
                      </span>
                    )
                  })}
                </div>
              </Form.Group>
            </Row>
            {isDesktopOrLaptop ?

              (historyState.selectedtransactionType?.id === 'TRANSFER' || historyState.selectedtransactionType?.id === 'DEPOSIT' || historyState.selectedtransactionType?.id === 'MEMBER' || historyState.selectedtransactionType?.id === 'WITHDRAW' ?
                <Row>
                  <Col lg={4}>
                    <Form.Group as={Row}  >
                      <Form.Label column lg={4} className="history_date_label">{t('start_date')}:</Form.Label>
                      <Col lg={7} className="px-lg-0">
                        {/* <Form.Control
                        type="date"
                        placeholder={t('start_date')}
                        className="font_h6 input_startDate"
                        aria-label="startDate"
                        value={historyState.selectedStartDate ?? ''}
                        onChange={(evt) => { onChangeStartDate(evt.target.value, historyState.selectedEndDate) }}
                      /> */}
                        <DatePicker
                          selected={historyState.selectedStartDate}
                          onChange={(date) => onChangeStartDate(date, historyState.selectedEndDate)}
                          dateFormat="yyyy-MM-dd"
                          className="font_h5 input_endDate form-control"
                          placeholderText={'YYYY-MM-DD'}
                          aria-label="startDate"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group as={Row} >
                      <Form.Label column lg={4} className="history_date_label">{t('end_date')}:</Form.Label>
                      <Col lg={7} className="px-lg-0">
                        {/* <Form.Control
                        type="date"
                        placeholder={t('end_date')}
                        className="font_h6 input_endDate"
                        aria-label="endDate"
                        value={historyState.selectedEndDate ?? ''}
                        onChange={(evt) => { onChangeEndDate(historyState.selectedStartDate, evt.target.value, today) }}
                      /> */}

                        <DatePicker
                          selected={historyState.selectedEndDate}
                          onChange={(date) => onChangeEndDate(historyState.selectedStartDate, date, today)}
                          dateFormat="yyyy-MM-dd"
                          className="font_h5 input_endDate form-control"
                          placeholderText={'YYYY-MM-DD'}
                          aria-label="end_date"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {/* <Col lg={{ span: 2, offset: 2 }}> */}
                  <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                    <FaSearch />
                  </button>
                  {/* </Col> */}
                </Row> : (historyState.selectedtransactionType?.id === 'MONTHLY_COMMISSION' ? <Row>
                  <Form.Group className="mb-3" >
                    <Form.Label>{t('year')} :
                      <span className="form_required_input">* {t('required_select')}</span>
                    </Form.Label>
                    <div className="d-flex">
                      <DatePicker
                        selected={historyState.selectedYear}
                        onChange={(year) => onChangeYear(year)}
                        className="font_h5 input_endDate form-control"
                        placeholderText={'yyyy'}
                        aria-label="year"
                        dateFormat="yyyy"
                        showYearPicker
                      />

                      <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                        <FaSearch />
                      </button>
                    </div>
                  </Form.Group>

                </Row> : <Row>
                  <Form.Group className="mb-3" >
                    <Form.Label>{t('month')} :
                      <span className="form_required_input">* {t('required_select')}</span>
                    </Form.Label>
                    <div className="d-flex">
                      <DatePicker
                        selected={historyState.selectedMonth}
                        onChange={(month) => onChangeMonth(month)}
                        className="font_h5 input_endDate form-control"
                        placeholderText={'yyyy-MM'}
                        aria-label="month"
                        dateFormat="yyyy-MM"
                        showMonthYearPicker
                      />

                      <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                        <FaSearch />
                      </button>
                    </div>
                  </Form.Group>

                </Row>)
              ) : (
                historyState.selectedtransactionType?.id === 'MONTHLY_WIN_LOSS' ? <Row>
                  <Col> <Form.Group as={Row}  >

                    <Form.Label column className="history_date_label w-25">{t('month')}:</Form.Label>
                    <Col xs={9} className="px-xs-0">
                      <DatePicker
                        selected={historyState.selectedMonth}
                        onChange={(month) => onChangeMonth(month)}
                        className="font_h5 input_endDate form-control"
                        placeholderText={'YYYY-MM-DD'}
                        aria-label="month"
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                      />
                    </Col>
                  </Form.Group></Col>


                  <Col xs={{ span: 2 }}>
                    <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                      <FaSearch />
                    </button>
                  </Col>
                </Row> : (historyState.selectedtransactionType?.id === 'MONTHLY_COMMISSION' ? <Row>
                  <Col> <Form.Group as={Row}  >

                    <Form.Label column className="history_date_label w-25">{t('year')}:</Form.Label>
                    <Col xs={9} className="px-xs-0">
                      <DatePicker
                        selected={historyState.selectedYear}
                        onChange={(year) => onChangeYear(year)}
                        className="font_h5 input_endDate form-control"
                        placeholderText={'YYYY'}
                        aria-label="year"
                        dateFormat="yyyy"
                        showYearPicker
                      />
                    </Col>
                  </Form.Group></Col>


                  <Col xs={{ span: 2 }}>
                    <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                      <FaSearch />
                    </button>
                  </Col>
                </Row> : <Row>
                  <Col><Form.Group as={Row}  >

                    <Form.Label column className="history_date_label w-25">{t('start_date')}:</Form.Label>
                    <Col xs={9} className="px-xs-0">
                      <DatePicker
                        selected={historyState.selectedStartDate}
                        onChange={(date) => onChangeStartDate(date, historyState.selectedEndDate)}
                        dateFormat="yyyy-MM-dd"
                        className="font_h5 input_endDate form-control"
                        placeholderText={'YYYY-MM-DD'}
                        aria-label="startDate"
                      />
                    </Col>
                  </Form.Group></Col>
                  <Col> <Form.Group as={Row} >
                    <Form.Label column className="history_date_label w-25">{t('end_date')}:</Form.Label>
                    <Col xs={9} className="px-xs-0">
                      <DatePicker
                        selected={historyState.selectedEndDate}
                        onChange={(date) => onChangeEndDate(historyState.selectedStartDate, date, today)}
                        dateFormat="yyyy-MM-dd"
                        className="font_h5 input_endDate form-control"
                        placeholderText={'YYYY-MM-DD'}
                        aria-label="end_date"
                      />
                    </Col>
                  </Form.Group></Col>

                  <Col xs={{ span: 2 }}>
                    <button className="font_button color_button wallet_btnSubmit btnSearch" type="button" onClick={handleSubmit}>
                      <FaSearch />
                    </button>
                  </Col>
                </Row>)
              )
            }
          </Form>


          {
            historyState.historyTransaction?.length ? (
              <><div className="wallet_history_table_wrap">
                <Table className={`wallet_history_table ${historyState.selectedtransactionType?.id}`}>
                  <thead className='color_secondary'>

                    <tr>

                      {
                        HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]?.selectedTableColumn.map(function (item, index) {
                          return (
                            <th key={item}>{t(item)}</th>
                          )
                        })
                      }
                      {historyState.selectedtransactionType?.id !== "MONTHLY_COMMISSION" && <th></th>}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      historyState.historyTransaction.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map(function (item, rowindex) {
                        const _item = HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]
                        return (
                          <tr key={rowindex}>

                            {_item.selectedTableColumn.map((keyCell, cellIndex) => {
                              if (keyCell === 'paymentType_transactionDate') {
                                return (
                                  <td key={cellIndex}>
                                    {item.payment_type} <br />
                                    {item.transaction_date}


                                  </td>
                                );
                              } else if (keyCell === 'promotion') {
                                return (
                                  <td key={cellIndex}>
                                    {item.promotion_name} <br />
                                    {item.transaction_date}
                                  </td>
                                );
                              }
                              // else if (keyCell === 'transaction_date') {
                              //   return (
                              //     <td key={cellIndex}>
                              //     {dayjs(item[keyCell])?.tz(_timezone)}
                              //     {dayjs(item[keyCell])?.tz(_timezone).format('YYYY-MM-DD HH:mm:ss')}
                              //   </td>
                              //   );
                              // }
                              else if (keyCell === 'transaction_status') {
                                return (
                                  <td key={cellIndex}>
                                    {t(item[keyCell]?.toLowerCase().replace(" ", "_"))}
                                  </td>
                                );
                              } else if (keyCell === 'comm_month') {
                                return (
                                  <td key={cellIndex}>
                                    {item.commission_start_date} <br />
                                    {item.commission_end_date}
                                  </td>
                                );
                              }
                              else if (keyCell === 'calculated_commission') {
                                return (
                                  <td key={cellIndex} onClick={() => onClickDetailsDialog(item.id)} className={`${keyCell}`}>
                                    <span>{item[keyCell]}</span>
                                  </td>
                                );
                              } else {
                                return (
                                  <td key={cellIndex}>
                                    {item[keyCell]}
                                  </td>
                                );
                              }

                            })}
                            {historyState.selectedtransactionType?.id !== "MONTHLY_COMMISSION" && (<td onClick={() => onClickDetailsDialog(item)} >{t('view')}</td>)}
                          </tr>
                        )
                      })
                    }

                  </tbody>
                </Table>
              </div>
                <div className="history_current_showing">
                  Showing {Math.min((currentPage - 1) * itemsPerPage + 1, historyState.historyTransaction?.length)} to {Math.min(currentPage * itemsPerPage, historyState.historyTransaction?.length)} of {historyState.historyTransaction?.length}
                </div>
                <div className="history_paginationButton">
                  <button onClick={previousPage}>Previous</button>
                  {createPagination()}
                  <button onClick={nextPage}>Next</button>
                </div>
              </>) : <> <div className="history_noRecord_wrap"><img src={`${TENANT_BUCKET}/icon/noRecord.png`} alt="no record icon" /><label>{t('no_record')}</label></div> </>
          }
        </div>
        {(currentDetails) && (<Modal show={showDetailsDialog}
          onHide={() => setShowDetailsDialog(false)}
          id="historyDetailsDialog"
          className={`dialog_${historyState.selectedtransactionType?.id}`}
          centered >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter" className="subTitle">
              {t(historyState.selectedtransactionType?.name)}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              historyState.selectedtransactionType?.id === "MONTHLY_WIN_LOSS" ? (
                <>
                  <Table className='wallet_history_table '>
                    <thead className='color_secondary'>

                      <tr>

                        {

                          HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]?.allAttr.map(function (item, index) {
                            return (
                              <th key={item}>{t(item)}</th>
                            )
                          })
                        }

                      </tr>
                    </thead>
                    <tbody>
                      {
                        currentDetails?.summary?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map(function (item, rowindex) {
                          const _item = HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]
                          return (
                            <tr key={rowindex}>

                              {_item.allAttr.map((keyCell, cellIndex) => {
                                // console.log('keyCell',keyCell)
                                if (keyCell === 'member') {
                                  return (
                                    <td key={cellIndex}>
                                      {item.member}
                                    </td>
                                  );
                                } else if (keyCell === 'game_provider') {
                                  return (
                                    <td key={cellIndex}>
                                      {item.game_provider_label}
                                    </td>
                                  );
                                } else if (keyCell === 'company_wl') {
                                  return (
                                    <td key={cellIndex}>
                                      {formatAmount(item.company_win_loss ?? 0, appState.currencyFormat.decimal_point)}
                                    </td>
                                  );
                                }

                                else {
                                  return (
                                    <td key={cellIndex}>
                                      {item[keyCell]}
                                    </td>
                                  );
                                }

                              })}
                            </tr>
                          )
                        })
                      }

                    </tbody>
                  </Table>
                  <div className="history_current_showing">
                    Showing {Math.min((currentPage - 1) * itemsPerPage + 1, historyState.historyTransaction?.length)} to {Math.min(currentPage * itemsPerPage, historyState.historyTransaction?.length)} of {historyState.historyTransaction?.length}
                  </div>
                  <div className="history_paginationButton">
                    <button onClick={previousPage}>Previous</button>
                    {createPagination()}
                    <button onClick={nextPage}>Next</button>
                  </div>
                </>) :
                (historyState.selectedtransactionType?.id === "MONTHLY_COMMISSION" ?
                  <>
                    <div className="wallet_history_table_wrap">
                      <Table className='wallet_history_table '>
                        <thead className='color_secondary'>

                          <tr>
                            {/* <th>{t('currency')}</th> */}
                            {

                              HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]?.allAttr.map(function (item, index) {

                                return (
                                  <th key={item}>{t(item)}</th>
                                )
                              })
                            }

                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentDetails?.map(function (item, rowindex) {
                              const _item = HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]
                              return (<>
                                {item.transactions.map((transaction, _rowIndex) => (
                                  <tr key={_rowIndex}>
                                    {_item.allAttr.map((keyCell, cellIndex) => {
                                      if (keyCell === 'currency') {
                                        if (_rowIndex === 0) {
                                          return (
                                            <td key={cellIndex} rowspan={`${item?.transactions?.length + 1}`}>
                                              {item.currency}
                                            </td>
                                          );
                                        }
                                        return (<></>)
                                      }
                                      else {
                                        return (
                                          <td key={cellIndex}>
                                            {transaction[keyCell]}
                                          </td>
                                        );
                                      }
                                    })}
                                  </tr>
                                ))}
                                {item.total_member_deposit.map((transaction, _rowIndex) => (
                                  <tr key={_rowIndex}>
                                    {_item.allAttr.map((keyCell, cellIndex) => {
                                      if (keyCell === 'currency') {
                                        return (<></>)
                                      }
                                      else {
                                        return (
                                          <td key={cellIndex}>
                                            {transaction[keyCell]}
                                          </td>
                                        );
                                      }
                                    })}
                                  </tr>
                                ))} {item.total_member_withdraw.map((transaction, _rowIndex) => (
                                  <tr key={_rowIndex}>
                                    {_item.allAttr.map((keyCell, cellIndex) => {
                                      if (keyCell === 'currency') {
                                        return (<></>)
                                      }
                                      else {
                                        return (
                                          <td key={cellIndex}>
                                            {transaction[keyCell]}
                                          </td>
                                        );
                                      }
                                    })}
                                  </tr>
                                ))}
                                {item.totals.map((transaction, _rowIndex) => (
                                  <tr key={_rowIndex}>
                                    {_item.allAttr.map((keyCell, cellIndex) => {
                                      if (keyCell === 'currency') {
                                        return (<></>)
                                      }
                                      else {
                                        return (
                                          <td key={cellIndex}>
                                            {transaction[keyCell]}
                                          </td>
                                        );
                                      }
                                    })}
                                  </tr>
                                ))}


                              </>
                              )
                            })
                          }


                        </tbody>
                      </Table>
                    </div>

                    {/* <div className="wallet_history_table_wrap">
                      <Table className='wallet_history_table '>
                        <thead className='color_secondary'>

                          <tr>

                            {

                              HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]?.allAttr2.map(function (item, index) {
                                return (
                                  <th key={item}>{t(item)}</th>
                                )
                              })
                            }

                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentDetails?.map(function (item, rowindex) {
                              const _item = HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]
                              return (
                                <tr key={rowindex}>

                                  {_item.allAttr2.map((keyCell, cellIndex) => {

                                    return (
                                      <td key={cellIndex}>
                                        {item[keyCell]}
                                      </td>
                                    );


                                  })}
                                </tr>
                              )
                            })
                          }

                        </tbody>
                      </Table>
                    </div> */}

                  </> :
                  HISTORY_TABLE_FIELD[historyState.selectedtransactionType?.id]?.allAttr.map(function (item, index) {
                    if (item === 'transaction_status') {
                      return (
                        <div className="historyDetails_content_row" key={`${historyState.selectedtransactionType?.id}${item}${currentDetails[item]}`}>
                          <label>{t(item)}</label>
                          <p>{t(currentDetails[item]?.toLowerCase().replace(" ", "_"))}</p>
                        </div>
                      )
                    } else {
                      return (
                        <div className="historyDetails_content_row" key={`${historyState.selectedtransactionType?.id}${item}${currentDetails[item]}`}>
                          <label>{t(item)}</label>
                          <p>{currentDetails[item]}</p>
                        </div>
                      )
                    }

                  }))
            }
          </Modal.Body>
        </Modal>
        )}
      </div >
      {/* <Alert show={alertShow.show} onHide={onHideAlert} message={alertShow.message} type={alertShow.type} title={alertShow.title} /> */}
      {isLoading && (<Loading />)}

    </>
  );
}



export default History;